<template>
  <div
    v-if="display"
    class="line-item__delete cart__confimation"
  >
    <p class="cart__confimation__heading">
      {{ $modeoL10n.are_you_sure_you_want_to_remove }}
      <template v-if="quantity > 1">
        {{ quantity }} {{ $modeoL10n.remove_products_confirmation }}
      </template>
      <template v-if="quantity == 1">
        {{ $modeoL10n.remove_product_confirmation }}
      </template>?
    </p>
    <div class="cart__confimation__actions cart__confimation__actions--small">
      <button
        class="btn btn--secondary btn--secondary-small btn--inline"
        @click.prevent="cancel()"
      >
        {{ $modeoL10n.cancel }}
      </button>
      <button
        class="btn btn--small btn--inline"
        @click.prevent="confirm()"
      >
        {{ $modeoL10n.remove }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
    props: {
        display: Boolean,
        quantity: {
          type: Number,
          default: 0,
        },
    },

    data : function () {
        return {
        }
    },

    created: function () {
    },

    methods: {

        confirm() {
            this.$emit("confirm");
        },

        cancel() {
            this.$emit("cancel");
        },

    },
}
</script>
